import { Group, Maybe } from 'types/schema-generated-types';

const MAT_MAN_EDUCATOR_APP_ID = 12;

export const filterMatManGroups = (groups?: Maybe<Group[]>) =>
  groups?.filter(group => group.appId === MAT_MAN_EDUCATOR_APP_ID) ?? [];
